export default __webpack_public_path__ + "97496b4c20e82f70a025af507ac04013.js";